<h2 id="titulo" *ngIf="valueTemplate === 'CONTRAC' || valueTemplate === 'PRECONTRAC'" class="title2">Firma tu contrato
</h2>

<div class="uno" *ngIf="valueTemplate === 'CONTRAC' || valueTemplate === 'PRECONTRAC'">
  <p class="dos">Aquí está tu contrato:</p>
  <div *ngIf="valueTemplate === 'CONTRAC' || valueTemplate === 'PRECONTRAC'" class="div3">
    <mat-icon (click)="getAllDocs()">save_alt</mat-icon>
    <p>{{data.fileName}}.pdf</p>
  </div>
  <p *ngIf="valueTemplate === 'CONTRAC' || valueTemplate === 'PRECONTRAC'" class="letter">Aquí está tu contrato.
    Introduzca el <strong>código de
      validación</strong> de 8 dígitos que acabamos de
    enviar por SMS para firmarlo digitalmente.</p>
  <br>
  <div *ngIf="valueTemplate === 'CONTRAC' || valueTemplate === 'PRECONTRAC'" class="div2">
    <mat-icon (click)="getAllDocs()">save_alt</mat-icon>
    <p>{{data.fileName}}.pdf</p>
  </div>
  <p *ngIf="valueTemplate === 'CONTRAC' || valueTemplate === 'PRECONTRAC'" class="letter2"><strong>Firmando,
      reconoces
      haber leído, entendido y aceptado el
      contrato.</strong></p>



  <h2 class="code" *ngIf="valueTemplate === 'CONTRAC' || valueTemplate === 'PRECONTRAC'">Código de validación</h2>

  <div class="form">
    <iv-form *ngIf="otpFormConfig" #ivform [errorsForm]="errorMessages" [(columnsForm)]="otpFormConfig" [inModal]="true"
      [buttons]="null"></iv-form>
    <div class="contentForm">
      <p>{{ 'codigo_no_recibido' | translate }}</p><button [disabled]="forwardingOTPButton"
        (click)="forwardingOTP()">{{
        'reenviar_codigo' | translate }}</button>
    </div>
  </div>
</div>

<div *ngIf="valueTemplate !== 'CONTRAC' && valueTemplate !== 'PRECONTRAC'">
  <iv-form *ngIf="otpFormConfig" #ivform [errorsForm]="errorMessages" [(columnsForm)]="otpFormConfig" [inModal]="true"
    [buttons]="null"></iv-form>
  <div *ngIf="forwardOTP === 1" class="forwardOtpCode">
    <p class="forwardOtpCodeText">
      {{ 'codigo_no_recibido' | translate }}
    </p>
    <button id="fordwartOtpCodeBtn" [disabled]="forwardingOTPButton" (click)="forwardingOTP()"
      class="forwardOtpCodeButton">
      {{ 'reenviar_codigo' | translate }}
    </button>
  </div>
</div>
